<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <div class="report-list__item">
          <a class="report-list__title">
            <button class="toggleSwitch">
              <svg class="closed" fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 14.5L17 9.5L7 9.5L12 14.5Z" fill="#1551D0"/>
              </svg>
              <svg class="opened" fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.5 12L9.5 7L9.5 17L14.5 12Z" fill="#1551D0"/>
              </svg>
            </button>
            <span>{{ title }}</span>
          </a>
          <div
              class="report-list__download"
              @click.stop="download()"
              v-if="['ROLE_ADMIN', 'ROLE_VNII'].includes($user.role)"
          ></div>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <ResultMonitorRatingContent
            :period="period"
            :level="level"
            :legend="legend"
            :report-data-function="reportDataFunction"
            :region-and-department-info="regionAndDepartmentInfo"
            :only-current-region="onlyCurrentRegion"
            :only-current-department="onlyCurrentDepartment"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>
    <LoaderDialog :show="showLoaderDialog" />
  </v-expansion-panels>
</template>

<script>
import LoaderDialog from "@/components/elements/LoaderDialog.vue";
import ResultMonitorRatingContent from "@/components/resultmonitor_new/ResultMonitorRatingContent.vue";
import api from "@/modules/api";

export default {
  name: 'ActivityMonitorRating',
  components: {ResultMonitorRatingContent, LoaderDialog},
  props: [
    'period',
    'level',
    'regionAndDepartmentInfo',
    'title',
    'indicator',
    'reportDataFunction',
    'reportId',
    'legend',
    'onlyCurrentRegion',
    'onlyCurrentDepartment'
  ],
  data: () => ({
    showLoaderDialog: false,
    downloadTaskId: null,
  }),
  methods: {
    async download() {
      try {
        this.showLoaderDialog = true;

        const reportId = this.reportId || 7;
        const queryParams = new URLSearchParams({
          period: this.period.code,
        });
        if (reportId === 7) {
          queryParams.append('indicator_id', this.indicator.id);
        }
        if (this.level === 'czn') {
          queryParams.append('region_code', this.regionAndDepartmentInfo.region.code);
        }

        const response = (await api.get(
            `/reports/generate/activity_monitor/${reportId}?${queryParams.toString()}`
        )).payload;
        this.downloadTaskId = response.task_id;
        await this.checkTaskStatus();
      } catch (error) {
        console.error('Error generating report:', error);
        alert('Ошибка при генерации отчета!');
        this.showLoaderDialog = false;
      }
    },
    async checkTaskStatus() {
      try {
        const response = (await api.get(`/reports/status/${this.downloadTaskId}`)).payload;
        if (response.status === 'SUCCESS') {
          await this.downloadFile();
        } else {
          setTimeout(this.checkTaskStatus, 2000);
        }
      } catch (error) {
        console.error('Error checking task status:', error);
        alert('Ошибка при проверке статуса задачи!');
        this.showLoaderDialog = false;
      }
    },
    async downloadFile() {
      try {
        const blob = (await api.get(`/reports/download/${this.downloadTaskId}`, null, 'blob')).payload;
        this.$downloadBlob(blob, `${this.title}.xlsx`);
        this.showLoaderDialog = false;
      } catch (error) {
        console.error('Error downloading file:', error);
        alert('Ошибка при скачивании файла!');
        this.showLoaderDialog = false;
      }
    },
  },
};
</script>
